<template>
	<b-container fluid>
		<b-row>
			<b-col sm="12">
				<card>
					<template v-slot:headerTitle>
						<h4 class="card-title">Courses</h4>
					</template>
					<template v-slot:headerAction>
						<div class="float-right">
							<b-button v-b-modal.course-modal variant="primary" class="btn-sm">Add Course</b-button>
						</div>
					</template>
					<template v-slot:body>
						<!----- Listing length and search starts ----->
						<div class="row listing-length-row">
							<div class="col-sm-12 col-md-6">
								<div class="listing-length" >
									<label
										>Show
										<select class="form-control" v-model="listing_length" @change="fetchCourse()">
											<option value="5">5</option>
											<option value="10">10</option>
											<option value="15">15</option>
										</select>
										entries
									</label>
								</div>								
							</div>
							<div class="col-sm-12 col-md-6">
								<div class="div-search">
									<label>
										<input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchCourse()" />
									</label>
								</div>							
								<div class="div-search mr-2">
									<select class="form-control" v-model="status" @change="fetchCourse()">
										<option value="">All</option>
										<option value="1">Published</option>
										<option value="2">Unpublished</option>
									</select>
								</div>
							</div>
						</div>
						<!----- Listing length and search ends ----->

						<!--- Listing starts ----->
						<div class="table-responsive">
							<table id="datatable" class="table data-table table-striped table-bordered dataTable">
								<thead>
									<tr>
										<th width="10%">Course Name</th>
										<th width="10%">Duration (in years)</th>
										<th width="15%">Created on</th>
										<th width="10%">Options</th>
									</tr>
								</thead>
								<tbody v-if="Boolean(courses.length)">
									<tr v-for="course in courses" :key="course.id">
										<td>{{ course.course }}</td>
										<td>{{ course.duration }}</td>						<td>{{ course.created_at | formatDateTime }}</td>
										<td>
											<b-button variant="primary" class="btn btn-sm mt-2 mr-1" @click="editCourse(course)">Edit</b-button>
											
											<b-button variant="danger" class="btn mt-2 mr-1 btn-sm" @click="deactivateCourse(course)" v-if="course.status == 1">Unpublish</b-button>
											<b-button variant="success" class="btn mt-2 mr-1 btn-sm" @click="activateCourse(course)" v-else>Publish</b-button>
										</td>
									</tr>
									
								</tbody>	
								<tbody v-else>
									<tr>
										<td colspan="4" class="text-center">No data</td>
									</tr>
								</tbody>							
							</table>
						</div>
						<!-- Listing ends -->
						<!---- modal starts ---->
						<b-modal ref="course-modal" id="course-modal" :title="modal_title" hide-footer @hidden="clearForm()">
							<b-form @submit.prevent="addCourse">								<b-col md="12" class="form-group">
									<label class="control-label">Course Name<span class="required">*</span></label>
									<b-form-input v-model="course.course_name" v-bind:class="{ 'is-invalid': Boolean(errors.course_name) }"></b-form-input>
									<div v-for="(val, index) in errors.course_name" :key="index" class="invalid-feedback">
										<p class="mb-0">{{ val }}</p>
									</div>
								</b-col>
								<b-col md="12" class="form-group">
									<label class="control-label">Duration (in years)</label>									
									<select class="form-control" v-model="course.duration" v-bind:class="{ 'is-invalid': Boolean(errors.duration) }">
										<option v-if="!edit" value="">Select</option>
										<option value="1">1</option>
										<option value="2">2</option>
										<option value="3">3</option>
										<option value="4">4</option>
									</select>
									<div v-for="(val, index) in errors.duration" :key="index" class="invalid-feedback">
										<p class="mb-0">{{ val }}</p>
									</div>
								</b-col>
								
								<b-col md="12">
									<b-button type="submit" class="mr-3" variant="primary">{{ button_title }}</b-button>
									<b-button class="" variant="light" @click="hideModal('course-modal')">Close</b-button>
								</b-col>
							</b-form>
						</b-modal>
						<!---- modal ends ----->
						<!----pagination starts --->
						<nav aria-label="Page navigation">
							<ul class="pagination">
								<li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
									<a class="page-link" href="#" @click.prevent="fetchCourse(page.url + '&limit=' + listing_length + '&keyword=' + keyword + '&status=' + status)" tabindex="-1">
										<span v-if="index == 0">Prev</span>
										<span v-else-if="index == pagination.length - 1">Next</span>
										<span v-else>{{ page.label }}</span>
									</a>
								</li>
							</ul>
						</nav>
						<!----pagination ends --->
					</template>
				</card>
			</b-col>
		</b-row>
	</b-container>
</template>
<script>
export default {
	name: "Courses",
	data() {
		return {
			courses: [],
			course: {
				id: null,
			   course_name: "",
			   duration: "",			   
			},
			
			modal_title: "Add Course",
			button_title: "Save",
			pagination: {},
			edit: false,
			course_status: {
				id: "",
				status: "",
			},
			keyword: "",
			showsearch: false,
			listing_length: 10,
			status: '',
			token: "",
			errors: {},
			activate: false,
         	deactivate: false,
           
         	active_page_url: null,
		};
	},
	mounted() {
			
	},

	created() {
		this.fetchCourse();
	},

		methods: {		    
		    getToken() {
				if (localStorage.token) {
					this.token = localStorage.token;
				} else {
					this.$vToastify.error("Session expired, please login again");
					this.$router.push({ name: "auth.login" });
				}
			},

			fetchCourse(page_url = null) 
			{
				let url = "/api/courses/index?limit=" + this.listing_length + "&keyword=" + this.keyword + "&status=" + this.status;
				page_url = page_url || url;
				this.active_page_url = page_url;   
				this.getToken();
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						this.courses = responseData.data;
						this.pagination = responseData.links;
					})
					.catch((err) => console.log(err));
			},

			showModal(modal) {
				this.$refs[modal].show();
			},
            
            addCourse() {
				this.getToken();
				let formData = new FormData();
				formData.append("course_name", this.course.course_name);
				formData.append("duration", this.course.duration);
				// alert(this.course.course_name);
				const config = {
					headers: {
						"content-type": "multipart/form-data",
						Authorization: "Bearer " + this.token,
					},
				};
				let url;
				if (!this.edit) {
					url = "/api/courses/add";
					this.active_page_url = null;
				} else {
					url = "/api/courses/update";
					formData.append("course_id", this.course.id);
				}
				this.$axios
					.post(url, formData, config)
					.then((response) => {
						if (response.data.status) {
							this.$vToastify.success(response.data.message);
						} else {
							this.$vToastify.error(response.data.message);
						}
						this.clearForm();
						this.hideModal("course-modal");
						this.fetchCourse(this.active_page_url);
					})
					.catch((error) => {
						console.log(error.response.data);
						if (error.response) {
							if (error.response.data.message) {
								this.errors = error.response.data.message;
								this.$vToastify.error(error.response.message);
							} else {
								this.$vToastify.error("Error!");
							}
						} else {
							this.$vToastify.error("Error!");
						}
					});
			},

			hideModal(modal) {
				this.$refs[modal].hide();
			},

			editCourse(course) {		
			    this.edit = true;
				this.course.id = course.id;
				this.course.course_name = course.course;
				this.course.duration = course.duration;
				this.errors = {};
				this.modal_title = "Edit Course";
				this.button_title = "Update";								
				this.showModal("course-modal");
			},
			clearForm() {								
				this.modal_title = "Add Course";
				this.button_title = "Add";

				this.edit = false;
				this.course.course_name = "";
				this.course.duration = "";
			},
			activateCourse(course) {
				this.activate = false;
		        this.$bvModal.msgBoxConfirm('Are you sure you want to publish this course?', {
		            title: 'Confirm',
		            size: 'sm',
		            buttonSize: 'sm',
		            okVariant: 'danger',
		            okTitle: 'Yes',
		            cancelTitle: 'No',
		            footerClass: 'p-2',
		            hideHeaderClose: false,
		            centered: true
		        })
		        .then(value => {
		            this.activate = value
		            if(this.activate){
						this.course_status.id = course.id;
						this.course_status.status = "1";
						this.updateCourseStatus();
					}
		        })
		         .catch(err => {
		            console.log(err);
		        })
			},
			deactivateCourse(course) {
				this.deactivate = false;
		        this.$bvModal.msgBoxConfirm('Are you sure you want to unpublish this course?', {
		            title: 'Confirm',
		            size: 'sm',
		            buttonSize: 'sm',
		            okVariant: 'danger',
		            okTitle: 'Yes',
		            cancelTitle: 'No',
		            footerClass: 'p-2',
		            hideHeaderClose: false,
		            centered: true
		        })
		         .then(value => {
		            this.deactivate = value
		            if(this.deactivate){
						this.course_status.id = course.id;
						this.course_status.status = "0";
						this.updateCourseStatus();
					}
         		})
         		.catch(err => {
           			console.log(err);
         		})
			},
			updateCourseStatus() {
				const config = {
					headers: {
						Authorization: "Bearer " + this.token,
					},
				};
				this.$axios
					.get("/api/courses/status?course_id=" + this.course_status.id + "&status=" + this.course_status.status, config)
					.then((response) => {
						if (response.data.status) {
							this.$vToastify.success(response.data.message);
						} else {
							this.$vToastify.error(response.data.message);
						}
						this.fetchCourse(this.active_page_url);
					})
					.catch((error) => {
						if (error.response) {
							if (error.response.data.message) {
								this.$vToastify.error(error.response.message);
							} else {
								this.$vToastify.error("Error!");
							}
						} else {
							this.$vToastify.error("Error!");
						}
					});
			},
		},	
};
</script>
